
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cricket/players/[...slug]",
      function () {
        return require("private-next-pages/cricket/players/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cricket/players/[...slug]"])
      });
    }
  